import type { ReactNode } from "react";
import { Card as UICard, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

// Thin wrapper over shadcn Card keeping the original (title, right, children) API.
// Compact density: 12px padding on phones, 16px at md+. `right` wraps under the
// title on small screens so filter bars are never clipped.
export default function Card({
  title,
  children,
  right,
  className,
}: {
  title?: string;
  children: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <UICard className={cn("min-w-0 gap-0 py-0", className)}>
      {(title || right) && (
        <CardHeader className="flex flex-col gap-2 border-b px-3 py-2 md:flex-row md:items-center md:justify-between md:px-4">
          {title && <CardTitle className="section-title">{title}</CardTitle>}
          {right && <div className="min-w-0">{right}</div>}
        </CardHeader>
      )}
      <CardContent className="p-3 md:p-4">{children}</CardContent>
    </UICard>
  );
}
